/**
 * @generated SignedSource<<64a7f221b2bd1e453ff2fa979291e1d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetBankAccountAnchorInput = {
  anchorBalance: number;
  anchorDate: any;
  id: string;
};
export type EditBankAccountDialogSetAnchorMutation$variables = {
  input: SetBankAccountAnchorInput;
};
export type EditBankAccountDialogSetAnchorMutation$data = {
  readonly setBankAccountAnchor: {
    readonly anchorBalance: number;
    readonly anchorDate: any;
    readonly currentBalance: number;
    readonly id: string;
  };
};
export type EditBankAccountDialogSetAnchorMutation = {
  response: EditBankAccountDialogSetAnchorMutation$data;
  variables: EditBankAccountDialogSetAnchorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "setBankAccountAnchor",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentBalance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBankAccountDialogSetAnchorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditBankAccountDialogSetAnchorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1b3dae1fb3118bfc0e76a78fb839d52f",
    "id": null,
    "metadata": {},
    "name": "EditBankAccountDialogSetAnchorMutation",
    "operationKind": "mutation",
    "text": "mutation EditBankAccountDialogSetAnchorMutation(\n  $input: SetBankAccountAnchorInput!\n) {\n  setBankAccountAnchor(input: $input) {\n    id\n    anchorDate\n    anchorBalance\n    currentBalance\n  }\n}\n"
  }
};
})();

(node as any).hash = "1da752ca735c4786324f676ab1738673";

export default node;
